import { motion } from "framer-motion"

const PORTRAIT = "https://static.lumi.new/07/0795793728f8c63b8391c2594fe607a4.webp"

function MusicScent() {
  return (
    <section className="relative w-full overflow-hidden bg-[#0c0c0c]">
      <div className="grid w-full items-stretch md:grid-cols-2">
        <div className="relative min-h-[70vh] overflow-hidden md:min-h-screen">
          <motion.img
            src={PORTRAIT}
            alt="邱鉦耀 Chill Jack Man 舞台演出"
            className="absolute inset-0 h-full w-full object-cover object-center grayscale-[15%]"
            initial={{ scale: 1.08, y: 24 }}
            whileInView={{ scale: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 2.4, ease: [0.22, 1, 0.36, 1] }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/20" />
        </div>

        <div className="flex flex-col items-center justify-center px-8 py-24 text-center md:px-16 md:py-24 lg:px-20">
          <motion.p
            className="font-sans-ui text-[11px] tracking-[0.48em] text-[#c4a574]"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 1 }}
          >
            03
          </motion.p>
          <motion.h2
            className="font-display mt-5 text-4xl text-[#f7f1e6] md:text-6xl"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 1.1, delay: 0.1 }}
          >
            音樂 × 氣味
          </motion.h2>
          <motion.p
            className="font-serif-tc mx-auto mt-14 max-w-md text-2xl leading-snug text-stone-100"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 1.2, delay: 0.2 }}
          >
            音樂成就了我，
            <br />
            氣味開啟了我的下一個舞台。
          </motion.p>
          <motion.p
            className="font-sans-ui mx-auto mt-10 max-w-xs text-[13px] leading-7 text-stone-400 md:mt-14 md:max-w-sm md:text-sm md:leading-8"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 1.2, delay: 0.3 }}
          >
            我們也希望有一天
            <br />
            大家談到創作者時
            <br />
            想到的不只有音樂人、導演或藝術家
            <br />
            也會想到氣味創作者。
          </motion.p>
        </div>
      </div>
    </section>
  )
}

export default MusicScent
